import { ChatListOrder } from '@api'

export const filterOptions = [
  { label: 'All', value: '' },
  { label: 'Priority', value: 'priority' },
  // For now { label: "Pinned", value: "pinned" },
  { label: 'Unread', value: 'unread' },
  { label: 'Unread with Tips', value: 'unread_tips' },
]
export const orderOptions = [
  { label: 'Newest First', value: ChatListOrder.RECENT },
  { label: 'Oldest First', value: ChatListOrder.OLD },
]
export const CHATS_PER_PAGE = 10
export const DEFAULT_SELECTED_LIST = { id: '0', name: 'All' }
export const UNREAD_LIST = {
  id: 'unread',
  name: 'Unread',
  tooltip:
    'This feature may not function optimally due to ongoing issues with OnlyFans.',
}
